import { render } from "./Group_information.vue?vue&type=template&id=1ff9d213"
import script from "./Group_information.vue?vue&type=script&lang=js"
export * from "./Group_information.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__